import React from 'react'
import BudgetRangeSlider from '../main/ui/slider/BudgetRangeSlider'

const LiveBudgetRangeSlider = props => {
  const max = props.value?.max || props.maxValue
  const min = props.value?.min || props.minValue

  const maxInputFormElement = document.getElementById(props.maxInputId)
  const minInputFormElement = document.getElementById(props.minInputId)

  const [value, setValue] = React.useState({ min, max })

  const handleChange = updatedValues => {
    const { max: updatedMax, min: updatedMin } = updatedValues

    if (maxInputFormElement) {
      maxInputFormElement.value = updatedMax || props.maxValue
      maxInputFormElement.dispatchEvent(new Event('input', { bubbles: true }))
    }

    if (minInputFormElement) {
      minInputFormElement.value = updatedMin || props.minValue
      minInputFormElement.dispatchEvent(new Event('input', { bubbles: true }))
    }

    setValue(updatedValues)
  }

  return (
    <BudgetRangeSlider
      {...props}
      value={value}
      monthlySchedule={props.monthlySchedule}
      weeklySchedule={props.weeklySchedule}
      subsidizedCareAccepted={props.subsidizedCareAccepted}
      subsidyName={props.subsidyName}
      onChange={handleChange}
    />
  )
}

export default LiveBudgetRangeSlider
